import { getPath } from './helpers/path';
import { baseRoutes } from './routeDefinitions';

// Re-export all, needed to prevent cyclic imports
export const routes = baseRoutes;

export const path = getPath;
export default routes;
